import React, { ReactNode } from 'react'
import './container.css';

interface Props {
    radial?   : boolean;
    children  : ReactNode;
    topColor? : string;
    btnColor? : string;
    theme?    : string;
    id?       : string;
    classes?  : string;
}

export class Container extends React.Component<Props> {

    getClasses()
    {
        if (this.props.classes !== undefined) {
            return "container " + this.props.classes;
        }
        else {
            return "container";
        }
    }

    render() {
        let style: React.CSSProperties = {};

        if (this.props.topColor !== undefined && this.props.btnColor !== undefined) {
            if (this.props.radial) {
                style = {
                    background: `radial-gradient(circle at left bottom, ${this.props.topColor}, ${this.props.btnColor})`
                }
            }
            else {
                style = {
                    background: `linear-gradient(to bottom, ${this.props.topColor}, ${this.props.btnColor})`
                }
            }
        }

        return (
            <div className={ this.getClasses() } data-theme={this.props.theme} style={style} id={ this.props.id }>
                { this.props.children }
            </div>
        );
    }
}

